
import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { TypographyH3, TypographyBody } from "@/components/ui/typography";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center p-8 text-muted-foreground space-y-4",
        className
      )}
    >
      {icon && <div className="mb-2 text-muted-foreground">{icon}</div>}
      <TypographyH3>{title}</TypographyH3>
      {description && (
        <TypographyBody className="text-muted-foreground max-w-sm">
          {description}
        </TypographyBody>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
